import React, { useEffect, useRef } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import config from '../../config/auth0';
import { useApiToken } from '../../hooks/useApiToken';

const PostLoginRedirectHandler: React.FC = () => {
  const { user, isAuthenticated, isLoading } = useAuth0();
  const navigate = useNavigate();
  const getAccessToken = useApiToken();
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    if (!isLoading && isAuthenticated && user) {
      hasRun.current = true;
      const fetchProfile = async () => {
        try {
          const accessToken = await getAccessToken();
          // Use internal auth service base URL for /me
          const checkResponse = await fetch(`${config.authServiceBaseUrl}/me`, {
            headers: { Authorization: `Bearer ${accessToken}` },
          });

          if (checkResponse.status === 403) {
              navigate('/unauthorized');
          } else if (checkResponse.ok) {
            navigate('/', { replace: true });
          } else {
            navigate('/error');
          }
        } catch (error) {
          navigate('/error');
        }
      };
      fetchProfile();
    } else if (!isLoading && !isAuthenticated) {
      hasRun.current = true;
      navigate('/login');
    }
  }, [isLoading, isAuthenticated, user, navigate]);

  return null;
};

export default PostLoginRedirectHandler; 